/**
 * @author: leroy
 * @date: 2021/11/3 11:22
 * @description：seo
 */
import { makeAutoObservable } from 'mobx';
import { enableStaticRendering } from 'mobx-react';

enableStaticRendering(typeof window === 'undefined');

type SEO = Partial<{
  title: string;
  keywords: string;
  description: string;
}>;

export class SeoStore {
  title: string | undefined = '人才招聘笔试管理系统_校招在线笔试题库';
  keywords: string | undefined =
    '云笔试,在线笔试,在线笔试系统,人才招聘笔试管理系统,校招在线笔试题库';
  description: string | undefined =
    '头部供应链SaaS服务商,海量免费笔试题库,智能组卷,为企业提供人才招聘在线笔试管理系统,助力企业完成人才甄选,降低人才选拔成本,以满足各大企业不同招聘岗位的需求.';

  setSEO = (data: SEO) => {
    Object.entries(data).forEach(([key, val]) => {
      if (key) this[key] = val;
    });
  };

  // 服务端数据
  hydrate = (data?: SEO) => {
    if (!data) return;
    Object.entries(data).forEach(([key, val]) => {
      if (key) this[key] = val;
    });
  };

  constructor() {
    makeAutoObservable(this);
  }
}

export type SeoState = Partial<InstanceType<typeof SeoStore>>;
